export const NAV_LOGO = "https://conn3ct.me/images/Transparent-Logo.png";
export const BLOB_LINK = "https://youibuilder.s3.ap-southeast-1.amazonaws.com/";
export const LOCAL_USER_TOKEN = localStorage.getItem("user");
export const LOCAL_LANGUAGE = localStorage.getItem("i18nextLng");
